//import React components
import PropTypes from "prop-types";
import {Col} from "reactstrap";

//import components


//Props settings for SideControlElement
SideControlElement.propTypes = {

}

SideControlElement.defaultProps = {

}

export default function SideControlElement ({className, label, info, ...props}) {
    return (
        <>
            <div className={`${className} row nowrap infoElem`}>
                {props.children ? (
                    props.children
                ) : (
                    <>
                        <Col sm={'auto'}>
                            <strong>{label}</strong>
                        </Col>
                        <Col sm={'auto'}>
                            <span>{info}</span>
                        </Col>
                    </>
                )}
            </div>
        </>
    )
}